import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { BsSmartwatch } from 'react-icons/bs'
import { Link } from 'react-router-dom';

const Dashboard = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios.get('https://api.codingveda.com/course/get_live_class')
      .then(res => {
        console.log("API response:", res.data.data[0]);
        setData(res.data.data);
      })
      .catch(err => console.error("Error fetching data:", err));
  }, []);
  return (
    <>
      <div className="container-fluid" style={{marginTop:'100px'}}>
        <div className="row">
          <div className="col-md-2"></div>
          <div className="col-md-7">
            <h4>Live Classes:</h4>
          {
            data.reverse().map((item, index) => (
                <div className="row">
                  <div className="col-md-4 course_card_left_part">
                    <div className="row">COURSE</div>
                    <div className="row">{item.course_topic}</div>
                  </div>
                  <div className="col-md-7 course_card_right_part">
                    <div className="row">
                      <div className="col-6">
                        <span style={{ fontSize: '20px' }}></span> <img src={item.img_url} alt="" style={{ height: '30px', borderRadius: '30px' }} /> {item.faculty_name}
                      </div>
                      <div className="col-6">
                        <span className='timeStampDesign'><BsSmartwatch /> {item.class_timing}</span>
                      </div>
                    </div>
                    <div className="row">CHAPTER {item.chepter_number}</div>
                    <div className="row">{item.topic_name}</div>
                    <div className="row d-flex justify-content-end"><a href={item.meet_link} className='d-flex button_live_class' target='_blank'>Join Live</a></div>
                  </div>
                </div>
            ))}
            </div>

          <div className="col-md-3 text-center">
            <div className="card test_card_bodys">
              <div className="card-body">
                <img
                  src='../../images/whatsapp.gif'
                  alt="Quiz"
                  className="quiz-image"
                  style={{ width: '40%', height: 'auto', marginBottom: '15px' }}
                />
                <h5>Join WhatsApp For Live Class Update</h5>
                <Link to="https://chat.whatsapp.com/LUnicZcKIQLJXcFp93zFnG" className='quiz_card_button'>Join WhatsApp</Link>
                <p>Ready to start increase your knowledge with www.codingveda.com</p>
              </div>
            </div>
            <br/>
            <div className="card test_card_body">
              <div className="card-body">
                <img
                  src='../../images/quiz_animi.gif'
                  alt="Quiz"
                  className="quiz-image"
                  style={{ width: '40%', height: 'auto', marginBottom: '15px' }}
                />
                <h5>Computer Teacher Exam Quiz</h5>
                <Link to="/ExerciseTest" className='quiz_card_button'>Start Quiz Now</Link>
                <p>Ready to start increase your knowledge with www.codingveda.com</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  )
}

export default Dashboard